(window["webpackJsonp"] = window["webpackJsonp"] || []).push([["main"],{

/***/ "./$$_lazy_route_resource lazy recursive":
/*!******************************************************!*\
  !*** ./$$_lazy_route_resource lazy namespace object ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function webpackEmptyAsyncContext(req) {
	// Here Promise.resolve().then() is used instead of new Promise() to prevent
	// uncaught exception popping up in devtools
	return Promise.resolve().then(function() {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	});
}
webpackEmptyAsyncContext.keys = function() { return []; };
webpackEmptyAsyncContext.resolve = webpackEmptyAsyncContext;
module.exports = webpackEmptyAsyncContext;
webpackEmptyAsyncContext.id = "./$$_lazy_route_resource lazy recursive";

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/modules/shared/views/page-not-found/page-not-found.component.html":
/*!*************************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/modules/shared/views/page-not-found/page-not-found.component.html ***!
  \*************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<p>page-not-found works!</p>\r\n");

/***/ }),

/***/ "./node_modules/tslib/tslib.es6.js":
/*!*****************************************!*\
  !*** ./node_modules/tslib/tslib.es6.js ***!
  \*****************************************/
/*! exports provided: __extends, __assign, __rest, __decorate, __param, __metadata, __awaiter, __generator, __exportStar, __values, __read, __spread, __spreadArrays, __await, __asyncGenerator, __asyncDelegator, __asyncValues, __makeTemplateObject, __importStar, __importDefault */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__extends", function() { return __extends; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__assign", function() { return __assign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__rest", function() { return __rest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__decorate", function() { return __decorate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__param", function() { return __param; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__metadata", function() { return __metadata; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__awaiter", function() { return __awaiter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__generator", function() { return __generator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__exportStar", function() { return __exportStar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__values", function() { return __values; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__read", function() { return __read; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spread", function() { return __spread; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spreadArrays", function() { return __spreadArrays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__await", function() { return __await; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncGenerator", function() { return __asyncGenerator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncDelegator", function() { return __asyncDelegator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncValues", function() { return __asyncValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__makeTemplateObject", function() { return __makeTemplateObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__importStar", function() { return __importStar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__importDefault", function() { return __importDefault; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}


/***/ }),

/***/ "./src/app/app-routing.module.ts":
/*!***************************************!*\
  !*** ./src/app/app-routing.module.ts ***!
  \***************************************/
/*! exports provided: AppRoutingModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppRoutingModule", function() { return AppRoutingModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _modules_shared_views_page_not_found_page_not_found_component__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./modules/shared/views/page-not-found/page-not-found.component */ "./src/app/modules/shared/views/page-not-found/page-not-found.component.ts");




const routes = [
    {
        path: '',
        redirectTo: 'auth',
        pathMatch: 'full'
    },
    {
        path: 'auth',
        loadChildren: () => __webpack_require__.e(/*! import() | app-modules-auth-auth-module */ "app-modules-auth-auth-module").then(__webpack_require__.bind(null, /*! ../app/modules/auth/auth.module */ "./src/app/modules/auth/auth.module.ts")).then(app => app.AuthModule)
    },
    {
        path: 'app',
        loadChildren: () => __webpack_require__.e(/*! import() | app-modules-dashboard-dashboard-module */ "app-modules-dashboard-dashboard-module").then(__webpack_require__.bind(null, /*! ../app/modules/dashboard/dashboard.module */ "./src/app/modules/dashboard/dashboard.module.ts")).then(app => app.DashboardModule),
    },
    { path: '**', component: _modules_shared_views_page_not_found_page_not_found_component__WEBPACK_IMPORTED_MODULE_3__["PageNotFoundComponent"] },
];
let AppRoutingModule = class AppRoutingModule {
};
AppRoutingModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"])({
        imports: [_angular_router__WEBPACK_IMPORTED_MODULE_2__["RouterModule"].forRoot(routes, {
                useHash: true
            })],
        exports: [_angular_router__WEBPACK_IMPORTED_MODULE_2__["RouterModule"]]
    })
], AppRoutingModule);



/***/ }),

/***/ "./src/app/app.component.css":
/*!***********************************!*\
  !*** ./src/app/app.component.css ***!
  \***********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2FwcC5jb21wb25lbnQuY3NzIn0= */");

/***/ }),

/***/ "./src/app/app.component.ts":
/*!**********************************!*\
  !*** ./src/app/app.component.ts ***!
  \**********************************/
/*! exports provided: AppComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppComponent", function() { return AppComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _app_global__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./app.global */ "./src/app/app.global.ts");
/* harmony import */ var _angular_service_worker__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/service-worker */ "./node_modules/@angular/service-worker/fesm2015/service-worker.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");





let AppComponent = class AppComponent {
    constructor(updates) {
        this.updates = updates;
        this.up = _app_global__WEBPACK_IMPORTED_MODULE_2__["UpGestao"];
    }
    ngOnInit() {
        if (this.updates.isEnabled) {
            Object(rxjs__WEBPACK_IMPORTED_MODULE_4__["interval"])(60000).subscribe(() => {
                this.updates.checkForUpdate();
            });
            this.updates.available.subscribe(() => {
                if (confirm("Uma nova atualização do Up Gestão está disponivel, deseja atualizar agora?")) {
                    this.updates.activateUpdate().then(() => document.location.reload());
                }
            });
        }
    }
    ngAfterViewInit() {
        setTimeout(() => this.up = _app_global__WEBPACK_IMPORTED_MODULE_2__["UpGestao"]);
        if (navigator.standalone == true) {
            this.toggleFullScreen();
        }
    }
    toggleFullScreen() {
        var doc = window.document;
        var docEl = doc.documentElement;
        var requestFullScreen = docEl.requestFullscreen || docEl.mozRequestFullScreen || docEl.webkitRequestFullScreen || docEl.msRequestFullscreen;
        var cancelFullScreen = doc.exitFullscreen || doc.mozCancelFullScreen || doc.webkitExitFullscreen || doc.msExitFullscreen;
        if (!doc.fullscreenElement && !doc.mozFullScreenElement && !doc.webkitFullscreenElement && !doc.msFullscreenElement) {
            requestFullScreen.call(docEl);
        }
        else {
            cancelFullScreen.call(doc);
        }
    }
};
AppComponent.ctorParameters = () => [
    { type: _angular_service_worker__WEBPACK_IMPORTED_MODULE_3__["SwUpdate"] }
];
AppComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-root',
        template: `<div class="contentChart" *ngIf="up.loading"> 
  <svg class="spinner" width="65px" height="65px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
  <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
  </svg>
  </div><p-toast position="top-left"></p-toast>
<router-outlet></router-outlet>`,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./app.component.css */ "./src/app/app.component.css")).default]
    })
], AppComponent);



/***/ }),

/***/ "./src/app/app.global.ts":
/*!*******************************!*\
  !*** ./src/app/app.global.ts ***!
  \*******************************/
/*! exports provided: UpGestao, getValorProduto, getPesquisa, formatarData, formatarPreco, extrairFormaPgto, getNatureza, Constantes, ajustaStrPreco */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UpGestao", function() { return UpGestao; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getValorProduto", function() { return getValorProduto; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPesquisa", function() { return getPesquisa; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "formatarData", function() { return formatarData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "formatarPreco", function() { return formatarPreco; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "extrairFormaPgto", function() { return extrairFormaPgto; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getNatureza", function() { return getNatureza; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Constantes", function() { return Constantes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ajustaStrPreco", function() { return ajustaStrPreco; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");

const UpGestao = {
    version: '0.0.1',
    loading: false,
    newOrderStarted: false,
    newOrder: {
        client: null,
        address: null,
        product: null,
        items: []
    },
    resetOrder: () => {
        UpGestao.newOrder = {
            client: null,
            address: null,
            product: null,
            items: []
        };
    }
};
function getValorProduto(objClientePedido, vlrProduto) {
    vlrProduto = numeral(numeral(vlrProduto).format('0.0000')).value();
    if (objClientePedido && vlrProduto > 0) {
        let objTipoCadastro = objClientePedido.cad_tipo_cadastro;
        if (objTipoCadastro) {
            if (objTipoCadastro.par_v01) {
                let vlrPercentual = (vlrProduto * numeral(numeral(objTipoCadastro.par_v01).format('0.00')).value()) / 100;
                let valor = (vlrProduto + vlrPercentual);
                return valor;
            }
        }
        return numeral(vlrProduto).format('0.0000');
    }
    return 0;
}
function getPesquisa(objeto, strComplemento) {
    let arrFiltro = [];
    let strFiltro = '';
    for (let k in objeto) {
        if (objeto[k] || objeto[k] === 0) {
            if (typeof (objeto[k]) === 'object') {
                if (objeto[k].length) {
                    arrFiltro.push(k + ':' + objeto[k].join('|'));
                }
            }
            else {
                arrFiltro.push(k + ':' + objeto[k]);
            }
        }
    }
    if (arrFiltro.length) {
        strFiltro = '?q=(' + arrFiltro.join(',') + ')';
    }
    if (strComplemento != '' && strComplemento != undefined) {
        strFiltro = (strFiltro === '') ? strComplemento : strFiltro + '&' + strComplemento;
    }
    return strFiltro;
}
function formatarData(data) {
    let arrDataOne = data.split(' ')[0];
    let arrDataTwo = arrDataOne.split('-');
    return (arrDataTwo[2] + '/' + arrDataTwo[1] + '/' + arrDataTwo[0]);
}
function formatarPreco(valor) {
    if (valor === null)
        return `0,00`;
    valor = `${valor}`.replace('.', ',');
    if (valor.lastIndexOf(',') === 0)
        valor = `0${valor}`;
    valor = (valor.lastIndexOf(',') < 0) ? `${valor},00` : `${valor}00`.substr(0, valor.lastIndexOf(',') + 3);
    return valor;
}
function extrairFormaPgto(formaPgto) {
    if (formaPgto) {
        let retorno = formaPgto.split('-');
        return parseInt(retorno[0].trim());
    }
    return null;
}
function getNatureza(idNatureza) {
    switch (idNatureza) {
        case Constantes.NATUREZAS.VENDA:
            return 'venda';
        case Constantes.NATUREZAS.ORCAMENTO:
            return 'orcamento';
        default:
            return 'venda';
    }
}
const Constantes = {
    PARCELAMENTO_VISTA: 1,
    PARCELAMENTO_PRAZO: 2,
    PARCELAMENTOS: ['1x', '2x', '3x', '4x', '5x', '6x', '7x', '8x', '9x', '10x', '11x', '12x', '13x', '14x', '15x', '16x', '17x', '18x', '19x', '20x', '21x', '22x', '23x', '24x'],
    TIPOS_PRODUCAO: ['Própria', 'Terceiros'],
    FORMAS_PAGAMENTO: ['Dinheiro', 'Boleto Bancário', 'Cartão'],
    NATUREZAS: {
        VENDA: 1,
        COMPRA: 2,
        DEVOLUCAO_VENDA: 3,
        DEVOLUCAO_COMPRA: 4,
        OUTRAS_SAIDAS: 5,
        OUTRAS_ENTRADAS: 6,
        ORCAMENTO: 11,
        SAIDA_INSUMOS: 15,
        ENTRADA_PRODUCAO: 16,
        PLANOS: 17,
        PRESTACAO_SERVICO: 31,
        TRANSPORTE: 57
    }
};
function ajustaStrPreco(strPreco) {
    const lastTwoDigits = strPreco.slice(-2); // Pegar os dois últimos dígitos
    const lastOneDigit = strPreco.slice(-1); // Pegar os dois últimos dígitos
    if (lastTwoDigits === '00') {
        return strPreco.slice(0, -2); // Remover os dois últimos zeros
    }
    else if (lastOneDigit == '0') {
        return strPreco.slice(0, -1); // Remover o ultimo zero
    }
    return strPreco; // Retornar o valor original se os dois últimos dígitos não forem 00
}


/***/ }),

/***/ "./src/app/app.module.ts":
/*!*******************************!*\
  !*** ./src/app/app.module.ts ***!
  \*******************************/
/*! exports provided: AppModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppModule", function() { return AppModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_platform_browser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/platform-browser */ "./node_modules/@angular/platform-browser/fesm2015/platform-browser.js");
/* harmony import */ var _angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/platform-browser/animations */ "./node_modules/@angular/platform-browser/fesm2015/animations.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_locales_pt__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/common/locales/pt */ "./node_modules/@angular/common/locales/pt.js");
/* harmony import */ var _angular_common_locales_pt__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_angular_common_locales_pt__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _app_routing_module__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./app-routing.module */ "./src/app/app-routing.module.ts");
/* harmony import */ var _app_component__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./app.component */ "./src/app/app.component.ts");
/* harmony import */ var _modules_shared_views_page_not_found_page_not_found_component__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./modules/shared/views/page-not-found/page-not-found.component */ "./src/app/modules/shared/views/page-not-found/page-not-found.component.ts");
/* harmony import */ var _angular_service_worker__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @angular/service-worker */ "./node_modules/@angular/service-worker/fesm2015/service-worker.js");
/* harmony import */ var _environments_environment__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../environments/environment */ "./src/environments/environment.ts");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var primeng_api__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! primeng/api */ "./node_modules/primeng/fesm2015/primeng-api.js");
/* harmony import */ var _lib_http_interceptor__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./lib/http-interceptor */ "./src/app/lib/http-interceptor.ts");
/* harmony import */ var primeng_toast__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! primeng/toast */ "./node_modules/primeng/fesm2015/primeng-toast.js");
/* harmony import */ var _modules_shared_shared_module__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./modules/shared/shared.module */ "./src/app/modules/shared/shared.module.ts");
/* harmony import */ var _services_api_service__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./services/api.service */ "./src/app/services/api.service.ts");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");

















Object(_angular_common__WEBPACK_IMPORTED_MODULE_16__["registerLocaleData"])(_angular_common_locales_pt__WEBPACK_IMPORTED_MODULE_4___default.a);
let AppModule = class AppModule {
};
AppModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_3__["NgModule"])({
        declarations: [
            _app_component__WEBPACK_IMPORTED_MODULE_6__["AppComponent"],
            _modules_shared_views_page_not_found_page_not_found_component__WEBPACK_IMPORTED_MODULE_7__["PageNotFoundComponent"]
        ],
        imports: [
            _angular_platform_browser__WEBPACK_IMPORTED_MODULE_1__["BrowserModule"],
            _angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_2__["BrowserAnimationsModule"],
            _modules_shared_shared_module__WEBPACK_IMPORTED_MODULE_14__["SharedModule"],
            _angular_common_http__WEBPACK_IMPORTED_MODULE_10__["HttpClientModule"],
            primeng_toast__WEBPACK_IMPORTED_MODULE_13__["ToastModule"],
            _app_routing_module__WEBPACK_IMPORTED_MODULE_5__["AppRoutingModule"],
            _angular_service_worker__WEBPACK_IMPORTED_MODULE_8__["ServiceWorkerModule"].register('/sw-master.js', { enabled: _environments_environment__WEBPACK_IMPORTED_MODULE_9__["environment"].production })
        ],
        providers: [
            primeng_api__WEBPACK_IMPORTED_MODULE_11__["MessageService"],
            _services_api_service__WEBPACK_IMPORTED_MODULE_15__["ApiService"],
            { provide: _angular_core__WEBPACK_IMPORTED_MODULE_3__["LOCALE_ID"], useValue: 'pt-BR' },
            { provide: _angular_common_http__WEBPACK_IMPORTED_MODULE_10__["HTTP_INTERCEPTORS"], useClass: _lib_http_interceptor__WEBPACK_IMPORTED_MODULE_12__["HttpErrorInterceptor"], multi: true }
        ],
        bootstrap: [_app_component__WEBPACK_IMPORTED_MODULE_6__["AppComponent"]]
    })
], AppModule);



/***/ }),

/***/ "./src/app/lib/http-interceptor.ts":
/*!*****************************************!*\
  !*** ./src/app/lib/http-interceptor.ts ***!
  \*****************************************/
/*! exports provided: HttpErrorInterceptor */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HttpErrorInterceptor", function() { return HttpErrorInterceptor; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var src_environments_environment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! src/environments/environment */ "./src/environments/environment.ts");
/* harmony import */ var primeng_api__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! primeng/api */ "./node_modules/primeng/fesm2015/primeng-api.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var ngx_webstorage__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ngx-webstorage */ "./node_modules/ngx-webstorage/fesm2015/ngx-webstorage.js");
/* harmony import */ var _app_global__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../app.global */ "./src/app/app.global.ts");









let HttpErrorInterceptor = class HttpErrorInterceptor {
    constructor(messageService, router, local) {
        this.messageService = messageService;
        this.router = router;
        this.local = local;
    }
    intercept(request, next) {
        request = this.addToken(request);
        return Object(rxjs__WEBPACK_IMPORTED_MODULE_2__["timer"])(0).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["switchMap"])(() => next.handle(request).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["map"])((event) => event), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["catchError"])((error) => {
            const data = {
                status: error.status,
                message: error
            };
            console.log(data);
            if (error.status == 0) {
                this.messageService.add({ severity: 'error', summary: 'Ops...', detail: 'Sem conexão com a internet, impossivel realizar essa operação!' });
            }
            _app_global__WEBPACK_IMPORTED_MODULE_8__["UpGestao"].loading = false;
            // this.messageService.add({ severity: 'error', summary: 'Ops...', detail: error.message });
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_2__["throwError"])(error);
        }))));
    }
    addToken(request) {
        let session = this.local.retrieve(src_environments_environment__WEBPACK_IMPORTED_MODULE_4__["environment"].session);
        if (session) {
            request = request.clone({
                headers: request.headers.set("Authorization", `Bearer ${session.token}`)
            });
        }
        return request;
    }
    sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }
};
HttpErrorInterceptor.ctorParameters = () => [
    { type: primeng_api__WEBPACK_IMPORTED_MODULE_5__["MessageService"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_6__["Router"] },
    { type: ngx_webstorage__WEBPACK_IMPORTED_MODULE_7__["LocalStorageService"] }
];
HttpErrorInterceptor = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])()
], HttpErrorInterceptor);



/***/ }),

/***/ "./src/app/modules/shared/shared.module.ts":
/*!*************************************************!*\
  !*** ./src/app/modules/shared/shared.module.ts ***!
  \*************************************************/
/*! exports provided: SharedModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SharedModule", function() { return SharedModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var ngx_webstorage__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ngx-webstorage */ "./node_modules/ngx-webstorage/fesm2015/ngx-webstorage.js");






let SharedModule = class SharedModule {
};
SharedModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"])({
        declarations: [],
        imports: [
            _angular_common__WEBPACK_IMPORTED_MODULE_2__["CommonModule"],
            _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClientModule"],
            _angular_forms__WEBPACK_IMPORTED_MODULE_4__["ReactiveFormsModule"],
            _angular_forms__WEBPACK_IMPORTED_MODULE_4__["FormsModule"],
            ngx_webstorage__WEBPACK_IMPORTED_MODULE_5__["NgxWebstorageModule"].forRoot(),
        ],
        exports: [
            _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClientModule"],
            ngx_webstorage__WEBPACK_IMPORTED_MODULE_5__["NgxWebstorageModule"],
            _angular_forms__WEBPACK_IMPORTED_MODULE_4__["ReactiveFormsModule"],
            _angular_forms__WEBPACK_IMPORTED_MODULE_4__["FormsModule"]
        ]
    })
], SharedModule);



/***/ }),

/***/ "./src/app/modules/shared/views/page-not-found/page-not-found.component.css":
/*!**********************************************************************************!*\
  !*** ./src/app/modules/shared/views/page-not-found/page-not-found.component.css ***!
  \**********************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL21vZHVsZXMvc2hhcmVkL3ZpZXdzL3BhZ2Utbm90LWZvdW5kL3BhZ2Utbm90LWZvdW5kLmNvbXBvbmVudC5jc3MifQ== */");

/***/ }),

/***/ "./src/app/modules/shared/views/page-not-found/page-not-found.component.ts":
/*!*********************************************************************************!*\
  !*** ./src/app/modules/shared/views/page-not-found/page-not-found.component.ts ***!
  \*********************************************************************************/
/*! exports provided: PageNotFoundComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PageNotFoundComponent", function() { return PageNotFoundComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let PageNotFoundComponent = class PageNotFoundComponent {
    constructor() { }
    ngOnInit() {
    }
};
PageNotFoundComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-page-not-found',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./page-not-found.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/modules/shared/views/page-not-found/page-not-found.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./page-not-found.component.css */ "./src/app/modules/shared/views/page-not-found/page-not-found.component.css")).default]
    })
], PageNotFoundComponent);



/***/ }),

/***/ "./src/app/services/api.service.ts":
/*!*****************************************!*\
  !*** ./src/app/services/api.service.ts ***!
  \*****************************************/
/*! exports provided: ApiService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ApiService", function() { return ApiService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var src_environments_environment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! src/environments/environment */ "./src/environments/environment.ts");
/* harmony import */ var _app_global__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../app.global */ "./src/app/app.global.ts");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var primeng_api__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! primeng/api */ "./node_modules/primeng/fesm2015/primeng-api.js");
/* harmony import */ var ngx_webstorage__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ngx-webstorage */ "./node_modules/ngx-webstorage/fesm2015/ngx-webstorage.js");








let ApiService = class ApiService {
    constructor(http, router, messageService, storage) {
        this.http = http;
        this.router = router;
        this.messageService = messageService;
        this.storage = storage;
    }
    checkStatus() {
        return new Promise((resolve, reject) => {
            if (this.session) {
                resolve();
            }
            else {
                reject();
                this.messageService.add({
                    severity: "error",
                    summary: "Ops...",
                    detail: "Sua sessão foi finalizada, efetue acesso novamente!",
                });
                this.router.navigate(["/auth/login"]);
            }
        });
    }
    getImage(mid, product) {
        if (!mid) {
            return product
                ? "/assets/images/produto.png"
                : "/assets/images/avatar.png";
        }
        return "https://scripts.virtux.com.br/imageCache.php?id=".concat(mid);
    }
    salvarPedido(data) {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            yield this.checkStatus();
            const usr = this.session.user.emp_ident_emp;
            return new Promise((resolve, reject) => {
                this.http
                    .post(src_environments_environment__WEBPACK_IMPORTED_MODULE_3__["environment"].api.concat(usr).concat("/erp/vix-fin/mobile"), data)
                    .subscribe((response) => {
                    if (response.status == 200) {
                        resolve(response.records);
                    }
                    else {
                        _app_global__WEBPACK_IMPORTED_MODULE_4__["UpGestao"].loading = false;
                        this.messageService.add({
                            severity: "error",
                            summary: response.records.title || "Ops...",
                            detail: response.records.msg,
                        });
                        reject(response.records);
                    }
                }, (err) => reject(err));
            });
        });
    }
    login(data) {
        return new Promise((resolve, reject) => {
            this.http
                .post(src_environments_environment__WEBPACK_IMPORTED_MODULE_3__["environment"].api.concat("1006/sistema/auth/"), data)
                .subscribe((response) => {
                if (response.status == 200) {
                    this.storage.store(src_environments_environment__WEBPACK_IMPORTED_MODULE_3__["environment"].session, response.records);
                    setTimeout(() => {
                        resolve(response.records);
                    }, 100);
                }
                else {
                    _app_global__WEBPACK_IMPORTED_MODULE_4__["UpGestao"].loading = false;
                    this.messageService.add({
                        severity: "error",
                        summary: response.records.title || "Ops...",
                        detail: response.records.msg,
                    });
                    reject(response.records);
                }
            }, (err) => reject(err));
        });
    }
    cliente(idCliente) {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            yield this.checkStatus();
            const usr = this.session.user.emp_ident_emp;
            return new Promise((resolve, reject) => {
                this.http
                    .get(src_environments_environment__WEBPACK_IMPORTED_MODULE_3__["environment"].api
                    .concat(usr)
                    .concat("/erp/vix-cad/" + idCliente + "/?q=(cad_status:A)"))
                    .subscribe((response) => {
                    if (response.status == 200) {
                        resolve(response.records);
                    }
                    else {
                        _app_global__WEBPACK_IMPORTED_MODULE_4__["UpGestao"].loading = false;
                        this.messageService.add({
                            severity: "error",
                            summary: response.records.title || "Ops...",
                            detail: response.records.msg,
                        });
                        reject(response.records);
                    }
                }, (err) => reject(err));
            });
        });
    }
    getParam(assunto, filter) {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            yield this.checkStatus();
            return new Promise((resolve, reject) => {
                const usr = this.session.user.emp_ident_emp;
                this.http
                    .get(src_environments_environment__WEBPACK_IMPORTED_MODULE_3__["environment"].api.concat(usr).concat("/erp/vix-par/?" + filter))
                    .subscribe((response) => {
                    if (response.status == 200) {
                        let value = response.records;
                        resolve(value[assunto]);
                    }
                    else {
                        _app_global__WEBPACK_IMPORTED_MODULE_4__["UpGestao"].loading = false;
                        reject(response.records);
                    }
                }, (err) => reject(err));
            });
        });
    }
    findOne(entity, idCliente, extra) {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            yield this.checkStatus();
            const usr = this.session.user.emp_ident_emp;
            return new Promise((resolve, reject) => {
                this.http
                    .get(src_environments_environment__WEBPACK_IMPORTED_MODULE_3__["environment"].api
                    .concat(usr)
                    .concat("/erp/" + entity + "/" + idCliente)
                    .concat(extra ? extra : ""))
                    .subscribe((response) => {
                    if (response.status == 200) {
                        resolve(response.records);
                    }
                    else {
                        _app_global__WEBPACK_IMPORTED_MODULE_4__["UpGestao"].loading = false;
                        this.messageService.add({
                            severity: "error",
                            summary: response.records.title || "Ops...",
                            detail: response.records.msg,
                        });
                        reject(response.records);
                    }
                }, (err) => reject(err));
            });
        });
    }
    find(entity, filter, free) {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            yield this.checkStatus();
            let objPesquisa = filter;
            const usr = this.session.user.emp_ident_emp;
            let queryString = Object(_app_global__WEBPACK_IMPORTED_MODULE_4__["getPesquisa"])(objPesquisa, "limit=50&offset=0");
            const toConcat = free
                ? "/erp/" + entity
                : "/erp/" + entity + "/listar-fast/";
            return new Promise((resolve, reject) => {
                this.http
                    .get(src_environments_environment__WEBPACK_IMPORTED_MODULE_3__["environment"].api.concat(usr).concat(toConcat).concat(queryString))
                    .subscribe((response) => {
                    if (response.status == 200) {
                        resolve(response.records);
                    }
                    else {
                        _app_global__WEBPACK_IMPORTED_MODULE_4__["UpGestao"].loading = false;
                        this.messageService.add({
                            severity: "error",
                            summary: response.records.title || "Ops...",
                            detail: response.records.msg,
                        });
                        reject(response.records);
                    }
                }, (err) => reject(err));
            });
        });
    }
    calcularTributacao(data) {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            yield this.checkStatus();
            const usr = this.session.user.emp_ident_emp;
            const url = src_environments_environment__WEBPACK_IMPORTED_MODULE_3__["environment"].api
                .concat(usr)
                .concat("/erp/tributacao");
            return new Promise((resolve, reject) => {
                this.http.post(url, data).subscribe((response) => {
                    if (response.status == 200) {
                        resolve(response.records);
                    }
                    else {
                        _app_global__WEBPACK_IMPORTED_MODULE_4__["UpGestao"].loading = false;
                        this.messageService.add({
                            severity: "error",
                            summary: response.records.title || "Ops...",
                            detail: response.records.msg,
                        });
                        reject(response.records);
                    }
                }, (err) => reject(err));
            });
        });
    }
    ratearDescontoGeral(data) {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            yield this.checkStatus();
            const usr = this.session.user.emp_ident_emp;
            const url = src_environments_environment__WEBPACK_IMPORTED_MODULE_3__["environment"].api
                .concat(usr)
                .concat("/erp/vix-fin/ratear-valores-atributo/?op=orcamento");
            return new Promise((resolve, reject) => {
                this.http.post(url, data).subscribe((response) => {
                    if (response.status == 200) {
                        resolve(response.records);
                    }
                    else {
                        _app_global__WEBPACK_IMPORTED_MODULE_4__["UpGestao"].loading = false;
                        this.messageService.add({
                            severity: "error",
                            summary: response.records.title || "Ops...",
                            detail: response.records.msg,
                        });
                        reject(response.records);
                    }
                }, (err) => reject(err));
            });
        });
    }
    getLote(proCodPro) {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            yield this.checkStatus();
            const usr = this.session.user.emp_ident_emp;
            return new Promise((resolve, reject) => {
                this.http
                    .get(src_environments_environment__WEBPACK_IMPORTED_MODULE_3__["environment"].api
                    .concat(usr)
                    .concat("/erp/vix-pro/lote/?q=(pro_cod_pro:" + proCodPro)
                    .concat(",pro_tip_especifico:2)"))
                    .subscribe((response) => {
                    if (response.status == 200) {
                        resolve(response.records);
                    }
                    else {
                        _app_global__WEBPACK_IMPORTED_MODULE_4__["UpGestao"].loading = false;
                        this.messageService.add({
                            severity: "error",
                            summary: response.records.title || "Ops...",
                            detail: response.records.msg,
                        });
                        reject(response.records);
                    }
                }, (err) => reject(err));
            });
        });
    }
    getSugestoes(sugestoes) {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            yield this.checkStatus();
            const usr = this.session.user.emp_ident_emp;
            return new Promise((resolve, reject) => {
                this.http
                    .get(src_environments_environment__WEBPACK_IMPORTED_MODULE_3__["environment"].api.concat(usr).concat("/erp/vix-fin/carregar-sugestoes/" + sugestoes))
                    .subscribe((response) => {
                    if (response.status == 200) {
                        resolve(response.records);
                    }
                    else {
                        _app_global__WEBPACK_IMPORTED_MODULE_4__["UpGestao"].loading = false;
                        this.messageService.add({
                            severity: "error",
                            summary: response.records.title || "Ops...",
                            detail: response.records.msg,
                        });
                        reject(response.records);
                    }
                }, (err) => reject(err));
            });
        });
    }
    calcularTributacaoSugestao(data) {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            yield this.checkStatus();
            const usr = this.session.user.emp_ident_emp;
            const url = src_environments_environment__WEBPACK_IMPORTED_MODULE_3__["environment"].api
                .concat(usr)
                .concat("/erp/vix-fin/calcular-imposto-sugestoes/");
            return new Promise((resolve, reject) => {
                this.http.post(url, data).subscribe((response) => {
                    if (response.status == 200) {
                        resolve(response.records);
                    }
                    else {
                        _app_global__WEBPACK_IMPORTED_MODULE_4__["UpGestao"].loading = false;
                        this.messageService.add({
                            severity: "error",
                            summary: response.records.title || "Ops...",
                            detail: response.records.msg,
                        });
                        reject(response.records);
                    }
                }, (err) => reject(err));
            });
        });
    }
};
ApiService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpClient"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_5__["Router"] },
    { type: primeng_api__WEBPACK_IMPORTED_MODULE_6__["MessageService"] },
    { type: ngx_webstorage__WEBPACK_IMPORTED_MODULE_7__["LocalStorageService"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(ngx_webstorage__WEBPACK_IMPORTED_MODULE_7__["LocalStorage"])(src_environments_environment__WEBPACK_IMPORTED_MODULE_3__["environment"].session)
], ApiService.prototype, "session", void 0);
ApiService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: "root",
    })
], ApiService);



/***/ }),

/***/ "./src/environments/environment.ts":
/*!*****************************************!*\
  !*** ./src/environments/environment.ts ***!
  \*****************************************/
/*! exports provided: environment */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "environment", function() { return environment; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");

const environment = {
    api: 'https://api.virtux.com.br/v1/',
    //  api: 'http://localhost/v1/v1/',
    session: 'up.mobile',
    sessionCart: 'up.mobile.cart',
    production: true
};


/***/ }),

/***/ "./src/main.ts":
/*!*********************!*\
  !*** ./src/main.ts ***!
  \*********************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_platform_browser_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/platform-browser-dynamic */ "./node_modules/@angular/platform-browser-dynamic/fesm2015/platform-browser-dynamic.js");
/* harmony import */ var _app_app_module__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./app/app.module */ "./src/app/app.module.ts");
/* harmony import */ var _environments_environment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./environments/environment */ "./src/environments/environment.ts");





if (_environments_environment__WEBPACK_IMPORTED_MODULE_4__["environment"].production) {
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["enableProdMode"])();
}
Object(_angular_platform_browser_dynamic__WEBPACK_IMPORTED_MODULE_2__["platformBrowserDynamic"])().bootstrapModule(_app_app_module__WEBPACK_IMPORTED_MODULE_3__["AppModule"]).then(() => {
    if ('serviceWorker' in navigator && _environments_environment__WEBPACK_IMPORTED_MODULE_4__["environment"].production) {
        navigator.serviceWorker.register('/sw-master.js');
    }
}).catch(err => console.log(err));


/***/ }),

/***/ 0:
/*!***************************!*\
  !*** multi ./src/main.ts ***!
  \***************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! C:\dev\vix-mobile\src\main.ts */"./src/main.ts");


/***/ })

},[[0,"runtime","vendor"]]]);
//# sourceMappingURL=main-es2015.js.map